import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { HighestPlacementEducationExamFragment, StaticDataType } from "@ankaadia/graphql";
import { TranslocoService } from "@jsverse/transloco";
import { FieldType } from "@ngx-formly/core";
import { DatePicker } from "primeng/datepicker";
import { FloatLabel } from "primeng/floatlabel";
import { InputText } from "primeng/inputtext";
import { combineLatest } from "rxjs";
import { EducationExamService } from "../../features/education/education-exams/education-exam.service";
import { DeepReplaceDateWithTime } from "../../shared/date-time/deep-replace-date-with-time.type";
import { NewUiWrapperReadonlyComponent } from "../../shared/form/wrapper-readonly/new-ui-wrapper-readonly.component";
import { AppDatePipe, AppDateTimePipe } from "../../shared/pipes/date.pipe";
import { NewUiCalendarUtcFixDirective } from "../../shared/primeng/calendar-utc-fix/new-ui-calendar-utc-fix.directive";
import { StaticDataService } from "../../shared/static-data/static-data.service";

@Component({
  selector: "new-ui-formly-language-level-by-placement-test",
  templateUrl: "./new-ui-formly-language-level-by-placement-test.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    FloatLabel,
    InputText,
    DatePicker,
    AppDatePipe,
    AppDateTimePipe,
    NewUiWrapperReadonlyComponent,
    NewUiCalendarUtcFixDirective,
  ],
})
export class NewUiFormlyLanguageLevelByPlacementTestComponent extends FieldType implements OnInit {
  exam: DeepReplaceDateWithTime<HighestPlacementEducationExamFragment>;
  languageLevelLabel: string = null;

  constructor(
    private readonly educationExamService: EducationExamService,
    private readonly transloco: TranslocoService,
    private readonly staticDataService: StaticDataService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.formState.candidateId && this.formState.organizationId) {
      const language = this.transloco.getActiveLang();
      combineLatest([
        this.educationExamService
          .getHighestPlacementTest(this.formState.candidateId, this.formState.organizationId)
          .pipe(takeUntilDestroyed(this.destroyRef)),
        this.staticDataService.getStaticData(StaticDataType.LanguageModules, language),
      ]).subscribe(([exam, languageModules]) => {
        this.languageLevelLabel = languageModules.find((module) => module.value === exam?.languageLevel)?.label;
        this.exam = exam as DeepReplaceDateWithTime<HighestPlacementEducationExamFragment>;
        this.changeDetector.markForCheck();
      });
    }
  }
}
